<template>
  <vx-card class="mb-6">
    <form ref="form">
     
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vx-field type="input" class="w-full" label="Device Name" v-model="form.name" required v-validate="'required'" :disabled="isArchivedDevice" />
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">
            <p>e.g. "iPad1"</p>
          </span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <label class="vs-input--label"> Location <span class="vx-input--asterisk text-danger">*</span> </label>
          <div class="vs-con-input v-select--questions" v-if="
              !locations || (locations.items && locations.items.length === 0)
            ">
          </div>
          <v-select name="location" label="name" v-model="form.location" :options="locations.items || []" v-validate="'required'" :disabled="isArchivedDevice" />
          <p class="text-sm text-danger mt-1" v-if="errors.has('location')">{{ errors.first('location') }}</p>
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4"></div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <div class="flex justify-between">
            <label for="" class="vs-input--label"> Device Code <span class="vx-input--asterisk text-danger">*</span>
            </label>
        </div>

          <vx-field type="input" class="w-full" v-model="form.code" required  :disabled="true"
          v-validate="{
              required: true
            }"  />
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">
            <p>e.g. "wg2ea1"</p>
          </span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <div class="flex justify-between">
            <label for="" class="vs-input--label"> Allowed IP Addresses 
            </label>
        </div>
          <vx-field type="textarea" class="w-full" v-model="form.allowedIpAddress" :disabled="isArchivedDevice"  />
        </div>
        <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
          <span class="tooltip">
            <p>Leave blank to allow access from anywhere.  Or enter one address/mask per line in e.g. "232.23.23.1/24"</p>
          </span>
        </div>
      </div>

      <div class="contact-types-block">
        <vx-card title="Data Management" class="mb-6">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-4">
              <vx-field type="select" autocomplete class="w-full" label="Remember Visitors" :clearable="false" :disabled="isArchivedDevice" :options="{
                  items: rememberRulesOptions || []
                }" v-model="form.rememberRules" v-validate="'required'" required  />
            </div>
            <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
              <span class="tooltip">
                <p>All visitors should have the "Remember Me" flag set by default so they will appear in the dropdown of previous visitors at check-in</p>
                <ul>
                  <li><strong>Always</strong> - “Every visitor will have their details remembered and will appear in the autocomplete dropdown at check-in”</li>
                  <li><strong>Never</strong> - “No visitor details will be suggested to the visitor as they check-in unless manually enabled for that contact”</li>
                  <li><strong>Selected By Default</strong> - “The “Remember me” checkbox will be selected by default but the visitor can opt out”</li>
                  <li><strong>Unselected By Default</strong> - “The “Remember me” checkbox will be unselected by default but the visitor can opt in”</li>
                </ul> 
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-4">
              <div class="vx-field relative w-full">
                <vx-field type="number" step="1" class="w-full" label="Max Remember Time (Days)" v-model="form.maxRememberTime" :disabled="isArchivedDevice" />
              </div>
            </div>
            <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
              <span class="tooltip">Max Remember Time in Days</span>
            </div>
          </div>
        </vx-card>
      </div>
      

      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vs-alert color="warning">
            <small class="text-xs text-danger">* required fields</small>
          </vs-alert>
        </div>
      </div>
      <div class="vx-row vx-row__actions">
        <div class="vx-col w-full">
          <vs-button class="ml-auto" @click.prevent="saveChanges()" icon-pack="feather" icon="icon-check" icon-before :disabled="isArchivedDevice">Save Changes</vs-button>
        </div>
      </div>
    </form>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import { hostname } from '@/axios.js';
import { mapState, mapGetters } from 'vuex';
import { debounce } from '@/plugins/utils';

export default {
  components: { vSelect },
  props: {
    data: {
      type: Object,
      default() {
        return {
          code: '',
          name: '',
          maxRememberTime: 0
        };
      }
    },
    isArchivedDevice: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      form: {
        ...this.data,
        maxRememberTime: this.data.maxRememberTime ? this.data.maxRememberTime : 0,
      },
      rememberRulesOptions: [
        {
          text: "Always",
          value: 0
        },
        {
          text: "Never",
          value: 2
        },
        {
          text: "Selected By Default",
          value: 4
        },
        {
          text: "Unselected By Default",
          value: 8
        }
      ],
    };
  },
  computed: {
    locations () {
      return this.$store.state.visitManagement.locations;
    }
  },
  methods: {
    handleOnOpen(dates, value, component) {
      //this.autoSignoutTime = value ? value : `${this.$moment().format('DD-MM-YYYY')} 12:00`;
    },
    saveChanges() {
      const {
        form,
        $validator,
        $store,
        $vs,
        $nextTick,
        $autoFocusOnFirstError,
        errors,
        $refs,
        $route,
        $router
      } = this;
      $validator.validateAll().then(async isValid => {
        if (isValid) {
          console.log("submit form >>> ", this.form);
          const result = await $store
            .dispatch('visitManagement/updateDevice', {
              id: form.id,
              name: form.name,
              code: (form.code || '').trim(),
              location: form.location.id,
              allowedIpAddress:form.allowedIpAddress,
              maxRememberTime: parseFloat(form.maxRememberTime),
              rememberRules: form.rememberRules,
            })
            .then(res => {
              console.log("=res >>> ", res);
              const { query, params } = $route;
              if (query.redirect) return $router.push(query.redirect);
              if (!params.id) {
                return $router.push({
                  name: 'edit-device',
                  params: { id: res.data.id }
                });
              }
              $vs.notify({
                color: 'success',
                title: 'Device Updated',
                text: res.data.message
              });
              return res.data;
            })
            .catch(error => {
              console.error("saveChanges error",error);
            });
            if (!result)
            {
              result=this.form;
            }
            console.log("submit result >>> ", result);
          this.$emit('success', result);
        }
        $nextTick(() => {
          $autoFocusOnFirstError(errors);
          console.log((window.$ctrl = this));
        });
      });
    }
  },
  async created() {
    var managementLocations = this.$store.state.visitManagement.locations;
    if (!managementLocations.items){
      await Promise.all([
        this.$store.dispatch('visitManagement/fetchLocations', { limit: 1000 }),
      ])
    }
  }
};
</script>
